/* eslint react/prop-types: 0 */

import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal, ModalHeader, ModalBody, Form, Input } from "reactstrap";
import InputMask from "react-input-mask";
import { FormGroup, Button } from "semantic-ui-react";
import { SelectPerusahaan } from "../../component/Utils";
import { postDataAction } from "../../config/redux/action";

export const HeaderComp = (props) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.main.dataUser);
  const valuePerusahaan = useSelector((state) => state.main.perusahaanFilter);
  const [modal, setModal] = useState(false);
  const [DataInput, setDataInput] = useState({});
  const [isLoadingButton, setisLoadingButton] = useState(false);

  const handleDataInput = (event) => {
    const { name, value } = event.target;
    setDataInput({
      ...DataInput,
      [name]: name === "role" ? parseInt(value) : value,
    });
  };

  const toggle = () => setModal(!modal);

  const handleSubmit = (e) => {
    e.preventDefault();
    setisLoadingButton(true);
    const NewDataInput = {
      ...DataInput,
      perusahaanId: valuePerusahaan,
    };
    dispatch(
      postDataAction({
        dispatch: "POST_DATA_USER",
        title: "User",
        path: "user",
        body: NewDataInput,
      })
    ).then((res) => {
      setisLoadingButton(false);
      toggle();
      props.getData();
    });
  };

  return (
    <div className="card border-0 rounded-0">
      <div className="container py-4">
        <div className="row px-4">
          <div className="col-md-6 d-flex align-items-center mb-md-0 mb-3">
            <h3>Aktivitas Akun</h3>
          </div>
        </div>
      </div>
    </div>
  );
};
